import React from "react";
import { money } from "@/lib/financeApi";
import ObligationContent from "@/components/nds/windows/finance/ObligationContent";

const CFG = {
  key: "program_fees", api: "/program-fees", testid: "fin-fee", label: "Program fee", refType: "program_fee", summaryTone: "orange",
  summaryText: (s) => `${s.open_count} open · ${money(s.open_balance)} due`,
  feeTypes: [["program", "Program"], ["life_skills", "Life skills"], ["employment_services", "Employment services"], ["other", "Other"]],
};

export default function FinProgramFeesContent() {
  return <ObligationContent cfg={CFG} />;
}
